import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { GoogleMap, InfoWindow, Marker } from '@react-google-maps/api';
import React, { useCallback, useState } from 'react';
import { baseSize, getIcon } from "../../Helpers/map";
export var InspectionCityMap = function InspectionCityMap(_ref) {
  var mapLocations = _ref.mapLocations,
    mapCenter = _ref.mapCenter,
    containerStyle = _ref.containerStyle,
    staticAssetsHost = _ref.staticAssetsHost,
    siteCode = _ref.siteCode,
    zoom = _ref.zoom,
    baseUrl = _ref.baseUrl;
  var _a;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    hoveredMarker = _useState2[0],
    setHoveredMarker = _useState2[1];
  var mapOptions = {
    disableDefaultUI: true,
    zoomControl: true,
    gestureHandling: 'cooperative'
  };
  var basePin = {
    size: new google.maps.Size(baseSize.width, baseSize.height),
    scaledSize: new google.maps.Size(baseSize.width, baseSize.height),
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(baseSize.width / 2, baseSize.height / 2)
  };
  var iconInfo = Object.assign(Object.assign({}, basePin), {
    url: "".concat(staticAssetsHost).concat(getIcon(siteCode))
  });
  var goTo = useCallback(function (location) {
    return function (event) {
      var _a;
      window.location.assign("/".concat(baseUrl, "/").concat(location.name.toLowerCase(), "-").concat(location.id));
      (_a = event === null || event === void 0 ? void 0 : event.domEvent) === null || _a === void 0 ? void 0 : _a.stopPropagation();
    };
  }, [baseUrl]);
  var mouseOver = function mouseOver(location) {
    return function (event) {
      var _a;
      setHoveredMarker(location);
      (_a = event === null || event === void 0 ? void 0 : event.domEvent) === null || _a === void 0 ? void 0 : _a.stopPropagation();
    };
  };
  return /*#__PURE__*/React.createElement(GoogleMap, {
    mapContainerStyle: containerStyle,
    center: mapCenter,
    zoom: zoom,
    options: mapOptions
  }, (_a = mapLocations === null || mapLocations === void 0 ? void 0 : mapLocations.map) === null || _a === void 0 ? void 0 : _a.call(mapLocations, function (location) {
    return /*#__PURE__*/React.createElement(Marker, {
      key: "".concat(location.lat, "_").concat(location.lng),
      position: location,
      onMouseOver: mouseOver(location),
      onMouseOut: mouseOver(null),
      onClick: goTo(location),
      icon: iconInfo
    });
  }), hoveredMarker && /*#__PURE__*/React.createElement(InfoWindow, {
    position: {
      lat: hoveredMarker.lat,
      lng: hoveredMarker.lng
    }
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h3", null, hoveredMarker.name))));
};